"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayerContext = exports.LayerProvider = void 0;
exports.layerManagerReducer = layerManagerReducer;
var tslib_1 = require("tslib");
var React = require("react");
function layerManagerReducer(state, action) {
  switch (action.type) {
    case 'push':
      if (state.find(function (layer) {
        return layer === action.id;
      })) {
        return state;
      }
      return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(state), false), [action.id], false);
    case 'pop':
      return state.filter(function (layer) {
        return layer !== action.id;
      });
    default:
      return state;
  }
}
var defaultValues = {
  layers: [],
  dispatchLayerAction: function () {},
  appBaseRef: {
    current: null
  },
  layerRootRef: {
    current: null
  }
};
var LayerContext = React.createContext(defaultValues);
exports.LayerProvider = LayerContext.Provider;
var useLayerContext = function () {
  return React.useContext(LayerContext);
};
exports.useLayerContext = useLayerContext;